module.exports = __webpack_public_path__ + "img/unknown.e5a308f2.svg";